import React, { useState, useEffect } from "react";
import { useCCContext } from "../CC/CCContext";
import * as ccUtils from "../CC/utils";
import styles from "./ObjAssoc.module.css";
import ObjAssocIcon from "./ObjAssocIcon";

interface RecordProps {
  record: any;
}

const ObjAssoc: React.FC<RecordProps> = ({ record }) => {
  const [relatedRecords, setRelatedRecords] = useState<any[]>([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const ctx = useCCContext();

  useEffect(() => {
    const fetchInitialRecords = async () => {
      if (!record?.data?.record?.relatedid) return;

      const relatedIdsArray = Array.isArray(record.data.record.relatedid)
        ? record.data.record.relatedid
        : record.data.record.relatedid ? [record.data.record.relatedid] : [];

      try {
        const fetchedRecords = await Promise.all(
          relatedIdsArray.slice(0, 6).map(async (relatedId: string) => {
            const url = `${process.env.REACT_APP_BASE_URL}/?action=get&command=search&query=uniqid=${relatedId}&fields=*&responseFormat=json`;

            const response = await fetch(url);
            if (!response.ok) return null;

            const data = await response.json();
            return data?.records?.record ?? null;
          })
        );

        const validRecords = fetchedRecords.filter((rec) => rec !== null);
        setRelatedRecords(validRecords);
      } catch (error) {
        console.error("Error fetching related records:", error);
      }
    };

    fetchInitialRecords();
  }, [record]);

  const fetchMoreRecords = async () => {
    const relatedIdsArray = Array.isArray(record?.data?.record?.relatedid)
      ? record.data.record.relatedid
      : record?.data?.record?.relatedid ? [record.data.record.relatedid] : [];

    if (relatedRecords.length >= relatedIdsArray.length) return;

    const nextIndex = relatedRecords.length;
    const remainingIds = relatedIdsArray.slice(nextIndex, nextIndex + 6);

    try {
      const fetchedRecords = await Promise.all(
        remainingIds.map(async (relatedId: string) => {
          const url = `${process.env.REACT_APP_BASE_URL}/?action=get&command=search&query=uniqid=${relatedId}&fields=*&responseFormat=json`;

          const response = await fetch(url);
          if (!response.ok) return null;

          const data = await response.json();
          return data?.records?.record ?? null;
        })
      );

      const newRecords = fetchedRecords.filter((rec) => rec !== null);
      setRelatedRecords((prev) => [...prev, ...newRecords]);
    } catch (error) {
      console.error("Error fetching additional records:", error);
    }
  };

  const handleLinkClick = (event: React.MouseEvent, index: number) => {
    event.preventDefault();

    const globalIndex = currentIndex + index;
    const selectedRecord = relatedRecords[globalIndex] || {}; // ✅ Voorkomt crashes

    const objectNumber = selectedRecord?.data?.record?.objectnumber || "Onbekend";
    const uniqid = selectedRecord?.data?.record?.uniqid || "Onbekend";

    console.log("ObjectNumber:", objectNumber);
    console.log("UniqID:", uniqid);

    ccUtils.customSearch(ctx, "/Record/uniqid", "", `[${uniqid}]`, `notice liées: ${uniqid}`);
  };

  const handleNext = () => {
    if (currentIndex + 6 >= relatedRecords.length) {
      fetchMoreRecords();
    }
    setCurrentIndex((prev) => prev + 6);
  };

  const handlePrev = () => {
    if (currentIndex - 6 >= 0) {
      setCurrentIndex((prev) => prev - 6);
    }
  };

  return (
    <div className={styles.ObjAssoc}>
      {relatedRecords.length > 0 && (
        <div className={styles.header}>
          <br />
          <b>Les notices liées :</b>
          <br />
          <br />
        </div>
      )}

      {relatedRecords.length > 0 ? (
        <div className={styles.carouselContainer}>
          {currentIndex > 0 && (
            <button className={styles.arrowButton} onClick={handlePrev}>
              ⬅️
            </button>
          )}

          <div className={styles.imageContainer}>
            {relatedRecords.slice(currentIndex, currentIndex + 6).map((record, index) => (
              <ObjAssocIcon
                key={currentIndex + index}
                record={record}
                index={index}
                handleLinkClick={(e) => handleLinkClick(e, index)} // ✅ FIX: Klik werkt weer!
              />
            ))}
          </div>

          {currentIndex + 6 < (
            Array.isArray(record?.data?.record?.relatedid)
              ? record.data.record.relatedid.length
              : record?.data?.record?.relatedid
                ? 1 // Enkelvoudig ID → 1 gerelateerd record
                : 0
            ) && (
              <button className={styles.arrowButton} onClick={handleNext}>
                ➡️
              </button>
          )}
        </div>
      ) : (
        <p></p>
      )}
    </div>
  );
};

export default ObjAssoc;
